import { regEx } from 'utils/global/regEx'

type CleanedTextResult = {
  isValid: boolean
  cleanedText: string
  firstLetter: string | null
}

export const cleanAndValidateFirstLetterText = (
  text: unknown,
): CleanedTextResult => {
  const noText = !text
  const isNotString = typeof text !== 'string'
  const isEmptyString = noText || isNotString || text.trim() === ''
  const shouldReturnEmpty = isEmptyString

  if (shouldReturnEmpty) {
    return { isValid: false, cleanedText: '', firstLetter: null }
  }

  const removedLeadingTrailingWhitespace = text.trim()
  const removedZeroWidthCharacters = removedLeadingTrailingWhitespace.replace(
    regEx.zeroWidthCharacters,
    '',
  )
  const normalizedMultipleSpaces = removedZeroWidthCharacters.replace(
    regEx.multipleSpaces,
    ' ',
  )
  const cleanedText = normalizedMultipleSpaces.trim()

  if (cleanedText === '') {
    return { isValid: false, cleanedText: '', firstLetter: null }
  }

  const firstLetterChar = cleanedText.charAt(0)
  const isNotValidLetter = !regEx.validLetters.test(firstLetterChar)
  if (isNotValidLetter) {
    return { isValid: false, cleanedText, firstLetter: null }
  }

  return {
    isValid: true,
    cleanedText,
    firstLetter: firstLetterChar.toUpperCase(),
  }
}
